import type { BoxProps, TextProps as PolarisTextProps } from '@shopify/polaris';
import type { GThumbnailProps } from '~/presentation/ui';
export const GRID_SIZE = {
  SINGER: '10px',
  CHECKBOX: '50px',
  THUMBNAIL: '52px',
  PRODUCT_COLUMN: '248px',
  PRODUCT_COLUMN_SINGER: 'auto',
  PRICE_COLUMN: 150,
  NEW_PRICE_COLUMN: 150,
};

export const GIRD_HEADER = [
  GRID_SIZE['CHECKBOX'],
  GRID_SIZE['THUMBNAIL'],
  GRID_SIZE['PRODUCT_COLUMN'],
  GRID_SIZE['PRICE_COLUMN'] * 2 + 'px',
  GRID_SIZE['NEW_PRICE_COLUMN'] * 2 + 'px',
];
export const GIRD_HEADER_SINGER = [
  GRID_SIZE['SINGER'],
  GRID_SIZE['THUMBNAIL'],
  GRID_SIZE['PRODUCT_COLUMN_SINGER'],
  GRID_SIZE['PRICE_COLUMN'] * 2 + 'px',
  GRID_SIZE['NEW_PRICE_COLUMN'] * 2 + 'px',
];
export const GIRD_ROOT = [
  GRID_SIZE['CHECKBOX'],
  GRID_SIZE['THUMBNAIL'],
  GRID_SIZE['PRODUCT_COLUMN'],
  GRID_SIZE['PRICE_COLUMN'] * 2 + 'px',
  GRID_SIZE['NEW_PRICE_COLUMN'] * 2 + 'px',
];
export const GIRD_ROOT_SINGER = [
  GRID_SIZE['SINGER'],
  GRID_SIZE['THUMBNAIL'],
  GRID_SIZE['PRODUCT_COLUMN_SINGER'],
  GRID_SIZE['PRICE_COLUMN'] * 2 + 'px',
  GRID_SIZE['NEW_PRICE_COLUMN'] * 2 + 'px',
];
export const GIRD_PRICE_GROUP = [
  GRID_SIZE['PRICE_COLUMN'] + 'px',
  GRID_SIZE['PRICE_COLUMN'] + 'px',
];
export const GIRD_NEW_PRICE_GROUP = [
  GRID_SIZE['NEW_PRICE_COLUMN'] + 'px',
  GRID_SIZE['NEW_PRICE_COLUMN'] + 'px',
];

export const GRID_COLUMNS = {
  HEADER: GIRD_HEADER.join(' '),
  HEADER_SINGER: GIRD_HEADER_SINGER.join(' '),
  ROOT: GIRD_ROOT.join(' '),
  ROOT_SINGER: GIRD_ROOT_SINGER.join(' '),
  PRICE_GROUP: GIRD_PRICE_GROUP.join(' '),
  NEW_PRICE_GROUP: GIRD_NEW_PRICE_GROUP.join(' '),
};

export type CustomTextProps = Pick<
  PolarisTextProps,
  'as' | 'fontWeight' | 'variant' | 'tone' | 'truncate'
>;

export const TEXT_PROPS: Record<
  'HEAD_GROUP' | 'HEAD' | 'BODY' | 'SUB_BODY' | 'PRICE_GROUP',
  CustomTextProps
> = {
  HEAD: {
    as: 'p',
    variant: 'bodySm',
    fontWeight: 'medium',
    tone: 'subdued',
  },
  HEAD_GROUP: {
    as: 'h4',
    fontWeight: 'semibold',
    variant: 'headingMd',
  },
  BODY: {
    as: 'p',
    fontWeight: 'medium',
    variant: 'bodyMd',
    truncate: true,
  },
  SUB_BODY: {
    as: 'span',
    variant: 'bodyMd',
    tone: 'subdued',
  },
  PRICE_GROUP: {
    as: 'p',
    variant: 'bodyMd',
  },
};

export const BOX_BORDER: BoxProps = {
  borderColor: 'border',
  borderWidth: '025',
};

export const BOX_BORDER_START: BoxProps = {
  borderColor: BOX_BORDER['borderColor'],
  borderBlockStartWidth: BOX_BORDER['borderWidth'],
};
export const BOX_BORDER_END: BoxProps = {
  borderColor: BOX_BORDER['borderColor'],
  borderBlockEndWidth: BOX_BORDER['borderWidth'],
};

export const BOX_BORDER_INLINE: BoxProps = {
  borderColor: BOX_BORDER['borderColor'],
  borderInlineStartWidth: BOX_BORDER['borderWidth'],
  borderInlineEndWidth: BOX_BORDER['borderWidth'],
};

export const BOX_BACKGROUND: Record<'HEAD', BoxProps> = {
  HEAD: {
    background: 'bg-surface-secondary',
  },
};

export const BOX_PADDING: Record<
  'CELL' | 'PRICE_CELL' | 'HEAD_GROUP_CELL' | 'PRICE_GROUP_CELL' | 'COMPARE_PRICE_CELL',
  BoxProps
> = {
  CELL: {
    padding: '150',
  },
  HEAD_GROUP_CELL: {
    padding: '400',
  },
  PRICE_GROUP_CELL: {
    paddingBlock: '400',
  },
  PRICE_CELL: {
    padding: '400',
    paddingBlock: '200',
    paddingInlineEnd: '200',
  },
  COMPARE_PRICE_CELL: {
    padding: '400',
    paddingBlock: '200',
    paddingInlineStart: '200',
  },
};

export interface IThumbSizeValue {
  size: GThumbnailProps['size'];
  width: string;
  padding: BoxProps;
}

export const BOX_THUMB_SIZE: Record<'SMALL', IThumbSizeValue> = {
  SMALL: {
    size: 'small',
    width: '40px',
    padding: BOX_PADDING.CELL,
  },
};
export const THUMB_SIZE = 'SMALL';
export const COLOR_STYLE = {
  HOVER: 'hover:bg-[--p-color-bg-surface-hover]',
  STICKY_LEVEL_2: 'bg-[--p-color-bg-surface]', //sticky top-[53px] z-[89]
};

export const BOX_STICKY: Record<'LEVEL_1', BoxProps> = {
  LEVEL_1: {
    position: 'sticky',
    insetBlockStart: '0',
    zIndex: '90',
    background: 'bg-surface',
  },
};
